import { Component } from "react";
import { useDropzone } from "react-dropzone";
import styled from "styled-components";
import { getTheme } from "../../config/themeConfig";

export class DropzoneArea extends Component {
  render() {
    return (
      <DragClickDropzone
        setFiles={this.props.setFiles}
        setRejectedFileMessage={this.props.setRejectedFileMessage}
      />
    );
  }
}

export default DropzoneArea;

const getColor = (props) => {
  if (props.isDragAccept) {
    return getTheme().palette.primary.dark;
  }
  if (props.isDragReject) {
    return "#ff1744";
  }
  if (props.isDragActive) {
    return "#2196f3";
  }
  return "#eeeeee";
};

function DragClickDropzone(props) {
  const { getRootProps, isDragActive, isDragAccept, isDragReject } =
    useDropzone({
      // Note how this callback is never invoked if drop occurs on the inner dropzone
      onDropAccepted: (files) => {
        // console.log("added file by drag");
        props.setFiles(files);
      },
      onDropRejected: (fileRejections) => {
        // console.log("rejected file by drag");
        props.setRejectedFileMessage(fileRejections);
      },
      noClick: true,
      accept: {
        "text/xml": [".xml"],
        "application/xml": [".xml"],
        "text/plain": [".xml"],
      },
      maxFiles: 1,
      multiple: false,
    });

  return (
    <div className="container">
      <DragContainer
        {...getRootProps({
          className: "dropzone",
          isDragActive,
          isDragAccept,
          isDragReject,
        })}
      >
        <ClickDropzone
          setFiles={props.setFiles}
          setRejectedFileMessage={props.setRejectedFileMessage}
        />
      </DragContainer>
    </div>
  );
}

function ClickDropzone(props) {
  const { getRootProps, getInputProps } = useDropzone({
    // noDragEventsBubbling: true,
    onDropAccepted: (files) => {
      // console.log("added file by click");
      props.setFiles(files);
    },
    onDropRejected: (fileRejections) => {
      // console.log("rejected file by click");
      props.setRejectedFileMessage(fileRejections);
    },
    accept: {
      "text/xml": [".xml"],
      "application/xml": [".xml"],
      "text/plain": [".xml"],
    },
    maxFiles: 1,
    multiple: false,
  });

  return (
    <ClickContainer {...getRootProps({ className: "dropzone" })}>
      <input {...getInputProps()} />
      <p>Drag & Drop or Browse a NeTEx compatible XML file to upload</p>
    </ClickContainer>
  );
}

const DragContainer = styled.div`
  display: flex;

  border-width: 2px;
  border-radius: 2px;
  border-color: ${(props) => getColor(props)};
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
`;

const ClickContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 70px;
  border-radius: 2px;
  border-color: ${(props) => getColor(props)};
  border-style: dashed; */
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
  font-family: sans-serif;
  text-align: center;
`;
